/* eslint-disable dot-notation,object-shorthand */

/**
 * Яндекс метрика
 */
export const yaInit = () => {
  window.ym(parseInt(process.env['YANDEX_METRIKA_IDENTIFIER'], 10), 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true
  });
};

export const yaVisit = pathname => {
  window.ym(
    parseInt(process.env['YANDEX_METRIKA_IDENTIFIER'], 10),
    'hit',
    pathname
  );
};

export const yaGoal = targetName => {
  window.ym(
    parseInt(process.env['YANDEX_METRIKA_IDENTIFIER'], 10),
    'reachGoal',
    targetName
  );
};

/**
 * Google analytics
 */
export const gtagInit = () => {
  window.gtag('js', new Date());
  window.gtag('config', process.env['GOOGLE_ANALYTICS_IDENTIFIER']);
};

export const gtagVisit = pathname => {
  window.gtag('config', process.env['GOOGLE_ANALYTICS_IDENTIFIER'], {
    page_path: pathname
  });
};

export const gtagEvent = ({ action, category, label, value }) => {
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value
  });
};



// WEBPACK FOOTER //
// ./src/mt-react-common/utils/Analytics.js